import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { Typography, Button, TextField, Pagination } from '@mui/material';

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import TituloPagina2 from "conten/components/TituloPagina2";
import { addMessage } from "conten/mensajes/MessagesActions";
import { connect } from "react-redux";



const Mapa = ({ classes, addMessage }) => {

  const emojiIcon = (emoji) => () => (
    <div
      style={{
        fontSize: '20px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 20,
        height: 20,
        lineHeight: 1,
      }}
    >
      {emoji}
    </div>
  );

  return (
    <GridItem xs={12}>
      <Card>
        {/* <CardHeader icon>
          <CardIcon color="primary">

            {emojiIcon('🗺️')()}
          </CardIcon>
          <TituloPagina2
            texto='Tráfico en tiempo real'
            color='primary'
            classes={classes}
            style={{ height: "30px", display: "block", lineHeight: "30px" }}

          />
        </CardHeader> */}
        <CardBody style={{ padding: "0", height: "90vh" }}>

          <iframe src="https://embed.waze.com/iframe?zoom=16&lat=6.147493&lon=-75.374121&ct=livemap" width="100%" height="100%" allowfullscreen></iframe>
        </CardBody>

      </Card>
    </GridItem>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addMessage: (content) => dispatch(addMessage(content)),
  };
};

export default withStyles(extendedTablesStyle)(
  connect(
    null,
    mapDispatchToProps
  )(Mapa)
);